import type { ReviewItem } from '../../cataloglifecycle/framework';
import { cn } from '../../lib/cn';
import { Button } from '../ui/Button';

type Props = { items?: ReviewItem[] };

function statusColor(status: string) {
  switch (status) {
    case 'approved': return 'text-success-600';
    case 'in_review': return 'text-brand-600';
    case 'rejected': return 'text-error-600';
    default: return 'text-warning-600';
  }
}

export function ReviewApprovalQueue({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.id} className="flex items-center justify-between rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0">
            <div className="flex items-center gap-2">
              <span className="rounded bg-slate-100 px-1.5 py-0.5 text-xs dark:bg-slate-800">{item.type}</span>
              <span className={cn('text-xs font-medium capitalize', statusColor(item.status))}>{item.status.replace('_', ' ')}</span>
            </div>
            <p className="mt-1 truncate text-sm font-medium">{item.title}</p>
            <p className="text-xs text-slate-500">{item.assignee}</p>
          </div>
          {item.status === 'pending' && (
            <div className="flex shrink-0 gap-1">
              <Button variant="primary" size="sm">Approve</Button>
              <Button variant="secondary" size="sm">Reject</Button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
